import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';

// Assets
import GascoCaratulaPodcast from '../../assets/images/caratula.jpg';
import GascoEmisorPodcasting from '../../assets/images/logo-emisor-podcasting.svg';
import GascoIcoLink from '../../assets/images/ico-link.svg';
import GascoIcoTwitter from '../../assets/images/ico-twitter.svg';
import GascoIcoFacebook from '../../assets/images/ico-facebook.svg';
import GascoIcoPlayAzul from '../../assets/images/ico-play-azul.svg';

// Helpers
import { formatearFechaLarga } from '../../helpers/fecha';

// Services
import { getPodcasts } from '../../config/services/strapi/strapi';

// Types
import { Podcast as PodcastType } from '../../interfaces/types';

function Podcast() {
  const [cargando, setCargando] = useState(true);
  const [podcasts, setPodcasts] = useState<PodcastType[]>([]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    window.alert('Enlace copiado a su portapapeles');
  }

  useEffect(() => {
    const fetchPodcasts = async () => {
      setCargando(true);

      const rawPodcasts = await getPodcasts();
      const mappedPodcasts: PodcastType[] = rawPodcasts.map((podcast: any) => ({
        id: podcast.id,
        titulo: podcast.titulo,
        descripcion: podcast.descripcion,
        fecha: podcast.fecha,
        autor: podcast.autor,
        exponentes: podcast.exponentes || [],
        audioUrl: podcast.audio.url,
        portadaUrl: podcast.portada.url,
        slug: podcast.slug,
      }));
      
      setPodcasts(mappedPodcasts);
      setCargando(false);
    };

    fetchPodcasts();
  }, []);

  return (
    <main>
      {/* Hero */}
      <section className='px-[15px] lg:px-36 2xl:px-64' style={{ background: 'linear-gradient(90deg, #00A1DC 0%, #54C2BF 100%)' }}>
        <div className="grid grid-cols-12 pb-12 lg:gap-16 lg:pb-20 md:pt-6">
          <div className='px-[15px] lg:px-0 pt-18 md:pt-10 col-span-12 md:col-span-6'>
            <img src={GascoCaratulaPodcast} alt="" className='w-[280px] md:w-[340px] lg:w-[500px] h-auto' />
          </div>
          <div className="px-[15px] lg:px-0 col-span-12 md:col-span-6">
            <h2 className='!mt-[25.5px] lg:!mt-[32px] mb-4 !text-[48px] leading-16 2xl:!leading-[65px] text-white !font-bold'>Energía que transforma</h2>
            <p className='text-white text-[15px] leading-8 mb-6'>
              Cuando la energía se orienta hacia el bien común, se vuelve un motor fundamental para construir un futuro mejor para las nueva generaciones. Conversamos con diferentes expertos para abordar la evolución de la energía en diferentes industrias.
            </p>
            <a href="https://www.emisorpodcasting.com/" className='!rounded-sm !bg-black !text-white text-[13px] font-medium !px-[15px] py-[12px] mb-14'>
              Escúchanos en:
              <img src={GascoEmisorPodcasting} alt="Emisor Podcasting" className='inline-block ml-4' />
            </a>
            <h4 className='!text-[20px] text-white pt-4'>Compartir</h4>
            <ul className='flex items-center gap-6 mt-2'>
              <li>
                <button className='text-white cursor-pointer' onClick={handleCopyLink}>
                  <img src={GascoIcoLink} alt="link" className='inline-block mr-2' />
                </button>
              </li>
              <li>
                <a href={`http://twitter.com/share?text=Energ%C3%ADa%20que%20transforma&url=${encodeURIComponent(window.location.href)}&hashtags=gasco,energia`} target='_blank' className='text-white'>
                  <img src={GascoIcoTwitter} alt="twitter" className='inline-block mr-2' />
                </a>
              </li>
              <li>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target='_blank' className='text-white'>
                  <img src={GascoIcoFacebook} alt="facebook" className='inline-block mr-2' />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* Episodios */}
      <section className='bg-[#125067] -mt-6 -mb-4 px-[15px] lg:px-36 pb-24 lg:pb-10'>
        <div className="px-[15px] lg:px-0">
          <h3 className='text-white text-[36px] !font-normal pt-4 2xl:pt-10 pb-3'>Episodios</h3>
          <div className="grid grid-cols-12 md:gap-4">
            {
              cargando ?

                Array.from({ length: 6 }).map((_, index) => (
                  <div key={index} className="col-span-12 md:col-span-6 flex justify-start items-start mb-6 gap-4">
                    <ImageSkeleton className="w-[200px] h-[200px] md:h-[150px] lg:h-[200px] rounded-xl overflow-hidden" />
                    <TextSkeleton className="!mb-[20px]" />
                  </div>
                ))

                :

                podcasts.map((podcast: PodcastType) => (
                  <div className="col-span-12 md:col-span-6 grid grid-cols-12 md:gap-4 lg:gap-8 pb-6">
                    <div className="col-span-12 md:col-span-4 pr-3 md:pr-0">
                      <img src={podcast.portadaUrl} alt="" />
                    </div>
                    <div className='col-span-12 md:col-span-8 mb-6 pb-10 pr-3'>
                      <span className='text-xs uppercase text-[#b1b2b1] block'>{formatearFechaLarga(podcast.fecha)}</span>
                      <h4>
                        <NavLink
                          className='mt-4 !text-white !font-bold text-[22px] leading-6'
                          to={`/podcast/${podcast.slug}`}
                        >
                          {podcast.titulo}
                        </NavLink>
                      </h4>
                      <div className='-mt-3 pb-2'>
                        <span className='text-[#b1b2b1] !text-[12px]'>Por:</span> <span className='!text-[12px] uppercase text-white'>{podcast.autor}</span>
                      </div>
                      <div className="my-3 pb-3">
                        <p className='text-white text-[15px] leading-7'>
                          {podcast.descripcion.length > 150 ? `${podcast.descripcion.substring(0, 150)}...` : podcast.descripcion}
                        </p>
                      </div>
                      <NavLink
                        className="flex justify-start items-center gap-4 uppercase !text-white text-[15px] font-semibold"
                        to={`/podcast/${podcast.slug}`}
                      >
                        <img src={GascoIcoPlayAzul} alt="" />
                        <span>Escúchalo ahora</span>
                      </NavLink>
                    </div>
                  </div>
                ))
            }
          </div>
          <hr className='col-span-12 w-full bg-white block md:hidden' />
        </div>
      </section>
    </main>
  )
}

export default Podcast;